import { MatButtonToggleDefaultOptions } from "@angular/material/button-toggle";

export const buttonToggleDefaultOptions: MatButtonToggleDefaultOptions = {
  // Material 17 adds a checkmark to the selected toggle; v16 had none
  hideSingleSelectionIndicator: true,
  hideMultipleSelectionIndicator: true
};
